'use strict'

import Vue from 'vue'

import {
  checkVariable,
  getFirstOccurrenceInObject,
} from './helper'

const Router = {
  methods: {
    /**
     * @param {Object} routes
     * @return {Boolean}
     */
    has(routes) {
      try {
        const { app } = this.$router
        const route = app.$route
        let key = 'query'
        if (checkVariable(routes.params) && !checkVariable(routes.query)) {
          key = 'params'
        }
        const isNull = getFirstOccurrenceInObject(routes[key], null)
        if (isNull === null) {
          return null
        }
        const test = getFirstOccurrenceInObject(route[key], routes[key])
        if (!checkVariable(test)) {
          return false
        }

        return true
      } catch (error) {
        console.error(error)

        return false
      }
    },
    /**
     *
     * @param {Object} routes
     */
    pushRoute(routes) {
      const exists = this.has(routes)
      if (exists === false) {
        this.$router.push(routes)
          .catch(error => {
            console.error(error)
          })
      }
    },
  },
}

const Component = Vue.extend({
  name: 'new-router',
  mixins: [Router],
})

export default Component
